export default __webpack_public_path__ + "static/media/ico-furniture.78b29a79.svg";